<template>
  <!-- ======= Header ======= -->
  <header id="header" class="fixed-top">
    <div class="container d-flex align-items-center">
      <a href="/" class="logo me-auto"
        ><img src="assets/img/logo.png" alt=""
      /></a>
      <!-- Uncomment below if you prefer to use an image logo -->
      <!-- <h1 class="logo me-auto"><a href="index.html">Medicio</a></h1> -->

      <nav id="navbar" class="navbar order-last order-lg-0">
        <ul>
          <li><router-link class="nav-link" to="/">صفحه اصلی</router-link></li>
          <li><a class="nav-link scrollto" href="/#about">درباره ما</a></li>
          <li><a class="nav-link scrollto" href="/#services">خدمات</a></li>
          <li><a class="nav-link scrollto" href="/#Articles">مقالات</a></li>
          <li><a class="nav-link scrollto" href="/#faq">سوالات متداول</a></li>
          <li>
            <a class="nav-link scrollto" href="/#gallery">گالری تصاویر</a>
          </li>
          <li><a class="nav-link scrollto" href="#contact">تماس با ما</a></li>

          <li class="dropdown" v-if="!showModal">
            <a href="#"
              ><span>{{ username }} </span> &nbsp; &nbsp;<i
                class="bi bi-chevron-down"
              ></i
            ></a>
            <ul>
              <li>
                <a href="/profile">پروفایل کاربری {{ username }}</a>
              </li>
              <li><a href="/controlPanel/FileManager">مدیریت تصاویر</a></li>
              <li>
                <a href="/controlPanel/contentManagement">ویرایش محتوا</a>
              </li>
              <li><a href="#" @click="logout">خروج</a></li>
              <!-- <li class="dropdown">
                <a href="#"
                  ><span>Deep Drop Down</span> <i class="bi bi-chevron-left"></i
                ></a>
                <ul>
                  <li><a href="#">Deep Drop Down 1</a></li>
                  <li><a href="#">Deep Drop Down 2</a></li>
                  <li><a href="#">Deep Drop Down 3</a></li>
                  <li><a href="#">Deep Drop Down 4</a></li>
                  <li><a href="#">Deep Drop Down 5</a></li>
                </ul>
              </li> -->
            </ul>
          </li>
        </ul>
        <i class="bi bi-list mobile-nav-toggle"></i>
      </nav>
      <!-- .navbar -->

      <a
        v-if="showModal"
        class="appointment-btn"
        data-bs-toggle="modal"
        data-bs-target="#registerModal"
        @click="type = 'login'"
      >
        <i class="bi bi-lock-fill"></i> ورود</a
      >

      <!-- Modal -->
      <div
        v-if="showModal"
        class="modal fade"
        id="registerModal"
        tabindex="-1"
        aria-labelledby="registerModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5
                v-if="type == 'register'"
                class="modal-title"
                id="registerModalLabel"
              >
                ثبت نام
              </h5>
              <h5 v-else class="modal-title" id="registerModalLabel">ورود</h5>

              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div v-if="!showCode" class="text-center">
                لطفا شماره موبایل یا ایمیل خود را وارد نمایید
              </div>
              <br />
              <div v-if="showCode" class="text-center">
                شماره موبایل یا ایمیل {{ mobile }}
              </div>
              <br />
              <div v-if="showCode" class="text-center">
                <button class="btn appointment-btn" @click="showCode = false">
                  ویرایش
                </button>
              </div>
              <br />

              <div v-if="!showCode" class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"
                  >شماره موبایل یا ایمیل</span
                >
                <input
                  type="text"
                  class="form-control ltr"
                  @input="checkMobile"
                  placeholder=""
                  v-model="mobile"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  required
                />
                <div class="invalid-feedback">
                  شماره موبایل یا ایمیل نامعتبر می باشد
                </div>
              </div>
              <div v-if="showCode" class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"
                  >کد ارسال شده</span
                >
                <input
                  type="text"
                  class="form-control ltr"
                  @input="checkCode"
                  placeholder=""
                  v-model="code"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  required
                />
                <div class="invalid-feedback">کد وارد شده نامعتبر می باشد</div>
              </div>

              <div class="modal-footer padding0 border0">
                <button
                  type="button"
                  class="btn appointment-btn btn-modal-close"
                  data-bs-dismiss="modal"
                >
                  <i class="bi bi-x-circle"></i>
                  بستن
                </button>
                <button
                  v-if="!showCode"
                  @click="recieveCode"
                  type="button"
                  class="btn appointment-btn"
                >
                  <i class="bi bi-lock-fill"></i> دریافت کد
                </button>
                <button
                  v-if="showCode"
                  @click="loginWithCode"
                  type="button"
                  class="btn appointment-btn"
                >
                  <i class="bi bi-caret-left"></i> ورود
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <!-- End Header -->
</template>
<script>
import { useStore } from "vuex";
import { ref, computed } from "vue";
import Swal from "sweetalert2";
export default {
  setup() {
    let showCode = ref(null);
    let showModal = ref(true);
    let username = ref(null);
    let user = ref(null);
    const dynamicMenu = ref([]);
    let type = ref(null);
    const store = useStore();
    store.dispatch("getCurrentUser");

    setTimeout(() => {
      user = store.state.currentUser;
      if (user != undefined) {
        if (user.username != null) {
          user.JsonMenu.$values.forEach((element) => {
            dynamicMenu.value.push({
              code: element.code,
              name: element.name,
              route: element.route,
            });
          });
        } else {
          setTimeout(() => {
            user = store.state.currentUser;
            if (user.username != null) {
              user.JsonMenu.$values.forEach((element) => {
                dynamicMenu.value.push({
                  code: element.code,
                  name: element.name,
                  route: element.route,
                });
              });
            }
          }, 2000);
        }
      }
    }, 2000);

    username = window.localStorage.getItem("username");

    if (username == "null" || username == undefined || username == null) {
      showModal = true;
    } else {
      showModal = false;
    }

    function recieveCode() {
      store.dispatch("sendCode", { mobileNumber: this.mobile });
      showCode.value = true;
    }
    function checkMobile(e) {
      var result =
        commonMethod.Ismobile(this.mobile) || commonMethod.IsEmail(this.mobile);
      if (result) {
        e.currentTarget.classList.remove("is-invalid");
        e.currentTarget.classList.add("is-valid");
      } else {
        e.currentTarget.classList.add("is-invalid");
      }
    }
    function loginWithCode() {
      store.dispatch("loginWithCode", {
        mobileNumber: this.mobile,
        code: this.code,
      });
      setTimeout(() => {
        if (store.state.register_result.status === 200) {
          this.showModal = false;
          this.username = store.state.register_result.data.username;
          showAlert("موفق", store.state.register_result.message, "success");
        } else {
          showAlert("خطا", store.state.register_result.message, "error");
        }
      }, 800);
    }
    function showAlert(title, text, icon) {
      Swal.fire({
        title,
        text,
        icon,
      });
    }
    function logout() {
      store.dispatch("logout");
    }

    return {
      user,
      dynamicMenu,
      mobile: null,
      code: null,
      showCode,
      recieveCode,
      checkMobile,
      loginWithCode,
      showAlert,
      showModal,
      username,
      logout,
      type,
    };
  },
};
</script>

<style>
.modal-backdrop {
  z-index: 100;
}

.modal {
  top: 100px;
}
.fixed-top {
  padding-right: 0px;
}
</style>
